import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {ISmartEngageData} from './types';
import {AppState} from '../../../verticals/hotels-dweb/src/shared/store';
import {toggleLoadingSmartEngageAction, updateSmartEngageDataAction} from './actions';
import {smartEngageBannerListApi} from '@ibibo/hotels-smartengage-apis';
import parseUrlDateString from '@ibibo/date-utils/src/parseDateIntoUrlString';
import roomStringUtils from '@ibibo/hotel-utils/src/room-string-utils';

export const fetchSmartEngageDataThunk = (
  config = null,
  withParams = false,
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleLoadingSmartEngageAction(true));
    let params = {};
    const {common} = getState();
    const {destination, checkin, checkout, roomString} = common;
    const {_id: city_id = ''} = destination;
    const {sendNodeId, slots} = config;
    if (city_id) params = (sendNodeId && {node_id: city_id}) || {city_id};

    if (withParams) {
      const [roomCount, paxCount, childCount] = roomStringUtils.splitRoomString(roomString);
      params = {
        ...params,
        checkin_date: parseUrlDateString(checkin.date),
        checkout_date: parseUrlDateString(checkout.date),
        pax_adult: paxCount,
        pax_child: childCount,
        pax_room: roomCount,
      };
    }

    smartEngageBannerListApi({params, config})
      .then((response: ISmartEngageData) => {
        if (response.data && response.success && response.data && response.data.slots) {
          let filteredSlots = {};
          Object.keys(response.data.slots)
            .filter(item => slots.indexOf(item) !== -1)
            .map(key => {
              filteredSlots = {...filteredSlots, [key]: response.data.slots[key]};
            });
          dispatch(updateSmartEngageDataAction({slots: filteredSlots} as ISmartEngageData['data']));
        }
        dispatch(toggleLoadingSmartEngageAction(false));
      })
      .catch(err => {
        // ! do something for error case
        console.error(err);
        dispatch(toggleLoadingSmartEngageAction(false));
      });
    // }
  };
};
